module.exports = __webpack_public_path__ + "static/media/Community_Icon.635df94f.png";